var render = function render(){
  var _vm$item, _vm$item2, _vm$item3, _vm$item4, _vm$item5, _vm$item6, _vm$item7, _vm$item8;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Project Spectrum Event Details'
    }
  }), _c('router-link', {
    attrs: {
      "to": {
        name: 'events',
        query: {
          eventPage: _vm.eventPage,
          query: _vm.query,
          eventType: _vm.eventType,
          eventsArchived: _vm.isEventArchived
        }
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": _vm.primaryButtonColor
    }
  }, [_vm._v(" " + _vm._s(_vm.isEventArchived == 'true' ? 'Back to Events Archives' : 'Back to Recent Events') + " ")])], 1)], 1)], 1), _c('SocialMediaWidgets', {
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "type": 'news',
      "hasTopMargin": true
    }
  }), _c('section', {
    staticClass: "section section-blog p-0 mb-3"
  }, [_c('div', {
    staticClass: "container p-0 px-3 px-lg-0 px-xl-0"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "image-content",
    attrs: {
      "src": (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.bannerImage,
      "alt": (_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.photoDescription
    }
  })])]), _c('div', {
    staticClass: "col-12 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "event-details"
  }, [_c('div', {
    staticClass: "w-100 d-flex flex-row justify-content-start py-2 event-text event-header-text"
  }, [_vm._v(" " + _vm._s((_vm$item3 = _vm.item) === null || _vm$item3 === void 0 ? void 0 : _vm$item3.eventTitle) + " ")]), _vm.isMobile ? _c('div', {
    staticClass: "w-100 d-flex flex-row justify-content-start pb-2 event-text event-header-text"
  }, [_vm._v(" " + _vm._s(`${_vm.formatDate((_vm$item4 = _vm.item) === null || _vm$item4 === void 0 ? void 0 : _vm$item4.startAt)} ${_vm.formatTime((_vm$item5 = _vm.item) === null || _vm$item5 === void 0 ? void 0 : _vm$item5.startAt)}`) + " ")]) : _vm._e(), _c('div', {
    staticClass: "w-100 py-3 d-flex flex-column justify-content-start align-items-start event-description"
  }, [_c('span', {
    staticClass: "text-left",
    domProps: {
      "innerHTML": _vm._s((_vm$item6 = _vm.item) === null || _vm$item6 === void 0 ? void 0 : _vm$item6.description)
    }
  })]), !_vm.isMobile ? _c('div', {
    staticClass: "w-100 my-2 d-flex flex-column justify-content-start"
  }, [_c('div', {
    staticClass: "w-100 text-start event-header-text",
    staticStyle: {
      "height": "25px"
    }
  }, [_vm._v(" DATE ")]), _c('div', {
    staticClass: "w-100 text-start event-header-content",
    staticStyle: {
      "height": "25px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatDate((_vm$item7 = _vm.item) === null || _vm$item7 === void 0 ? void 0 : _vm$item7.startAt)) + " ")])]) : _vm._e(), !_vm.isMobile ? _c('div', {
    staticClass: "w-100 my-2 d-flex flex-column justify-content-start"
  }, [_c('div', {
    staticClass: "w-100 text-start event-header-text",
    staticStyle: {
      "height": "25px"
    }
  }, [_vm._v(" TIME ")]), _c('div', {
    staticClass: "w-100 text-start event-header-content",
    staticStyle: {
      "height": "25px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatTime((_vm$item8 = _vm.item) === null || _vm$item8 === void 0 ? void 0 : _vm$item8.startAt)) + " ")])]) : _vm._e()])])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }